import auth0Service from '@/services/auth0'
import quoteService from '@/services/quote'

export default {
  namespaced: true,
  state: {
    token: auth0Service.token,
    accessToken: auth0Service.accessToken,
    expiresAt: auth0Service.expiresAt
  },
  getters: {
    isAuthenticated (state) { return new Date().getTime() < state.expiresAt }
  },
  mutations: {
    setToken (state, token) { state.token = token },
    setAccessToken (state, accessToken) { state.accessToken = accessToken },
    setUser (state, user) { state.user = user },
    setExpiration (state, expiresAt) { state.expiresAt = expiresAt },
    logout (state) {
      state.token = undefined
      state.accessToken = undefined
      state.expiresAt = undefined
    }
  },
  actions: {
    async login (_, { username, password }) {
      await auth0Service.login({ username, password })
    },
    async logout ({ commit }) {
      await auth0Service.logout()
      commit('logout')
    },
    async signup ({ dispatch }, args) {
      const authResult = await auth0Service.signupAndAuthorize(args)

      // Don't send password to create user call
      delete args.password

      await quoteService.createUser({
        ...args,
        auth0UserId: authResult.userId
      })

      dispatch('saveAuthPayload', authResult)
    },
    async handleAuthCallback ({ commit, dispatch }) {
      const authResult = await auth0Service.parseHash()
      dispatch('saveAuthPayload', authResult)
      dispatch('startRenewalTimer')
    },
    async saveAuthPayload ({ commit }, authResult) {
      if (authResult && authResult.accessToken && authResult.idToken) {
        auth0Service.expiresAt = authResult.expiresIn
        commit('setExpiration', auth0Service.expiresAt)
        auth0Service.accessToken = authResult.accessToken
        commit('setAccessToken', auth0Service.accessToken)
        auth0Service.token = authResult.idToken
        commit('setToken', auth0Service.token)
      }
    },
    startRenewalTimer () {
      return auth0Service.startRenewalTimer()
    }
  }
}
